import emptyTransactions from '@/assets/lotties/empty_state.json';
import loadingError from '@/assets/lotties/payment_failure.json';

export const EVENTS = {
  TRANSACTIONS: {
    LATEST: {
      REFRESH: 'transactions.latest.refresh',
      REFRESHING: 'transactions.latest.refreshing',
      REFRESH_ERROR: 'transactions.latest.refresh_error',
      REFRESHED: 'transactions.latest.refreshed'
    },
    LIST_ALL: {
      REFRESH: 'transactions.list_all.refresh',
      REFRESHING: 'transactions.list_all.refreshing',
      REFRESH_ERROR: 'transactions.list_all.refresh_error',
      REFRESHED: 'transactions.list_all.refreshed'
    },
    DETAIL: {
      SHOW: 'transaction.detail.show',
      REFRESHING: 'transactions.detail.refreshing',
      REFRESH_ERROR: 'transactions.detail.refresh_error',
      REFRESHED: 'transactions.detail.refreshed'
    },
    MARK_AS_SUCCESS: 'transactions.mark_as_success',
    MARK_AS_REFUNDED: 'transactions.mark_as_refunded',
    RETRY_DESTINATION: 'transactions.retry_destination',
    UPDATE_REQUEST: 'transactions.update_request',
    UPDATING: 'transactions.updating',
    UPDATED: 'transactions.updated',
    UPDATE_ERROR: 'transactions.update_error'
  }
};

export const ENDPOINTS = {
  TRANSACTIONS: {
    GET_LATEST: '/onebpay-transactions/list?limit=10&group=lacasae',
    GET_LIST:
      '/onebpay-transactions/list?userId={userId}&limit={limit}&group=lacasae&offset={offset}',
    GET_DETAIL:
      '/onebpay-transactions/{id}?group=lacasae',
    UPDATE:
      '/onebpay-transactions/{id}/update?group=lacasae',
    MARK_SUCCESS:
      '/onebpay-transactions/{id}/mark-success?group=lacasae',
    MARK_REFUNDED:
      '/onebpay-transactions/{id}/mark-refunded?group=lacasae',
    RETRY_DESTINATION:
      '/onebpay-transactions/{id}/retry-destination?group=lacasae'
  }
};

export const TRANSACTIONS = {
  LOTTIES: {
    EMPTY: emptyTransactions,
    LOADING_ERROR: loadingError
  },

  SERVICES_LIST: [
    {
      id: '1xbet',
      name: '1xBet',
      bookmaker: '1xBet',
      description: 'Dépots & Retraits',
      descriptionLarge: 'Dépots & Retraits',
      logo: '/images/services/1xBetIco.svg',
      bannerImage: '/images/services/1xBetIco.svg',
      idFindingMockup: '/images/screenshots/1xbet-account-id-getting.webp',
      color: '#002E5E',
      isAvailable: true,
      isDarkBg: true,
      group: 'recharges'
    },
    {
      id: 'betwinner',
      name: 'Betwinner',
      bookmaker: 'Betwinner',
      description: 'Dépots & Retraits',
      descriptionLarge: 'Dépots & Retraits',
      logo: '/images/services/betwinner-full.png',
      bannerImage: '/images/services/betwinner-full.png',
      idFindingMockup: '/images/screenshots/betwinner-account-id-getting.webp',
      color: '#1F7E5C',
      isAvailable: true,
      isDarkBg: true,
      group: 'recharges'
    },
    {
      id: '1win',
      name: '1Win',
      bookmaker: '1Win',
      description: 'Dépots & Retraits',
      descriptionLarge: 'Dépots & Retraits',
      logo: '/images/services/1winIcon.svg',
      bannerImage: '/images/services/1winIcon.svg',
      idFindingMockup: '/images/screenshots/1win-account-id-getting.webp',
      color: '#080E1E',
      isAvailable: true,
      isDarkBg: true,
      group: 'recharges'
    },
    {
      id: 'eightStarz',
      name: '888Starz',
      bookmaker: '888Starz',
      description: 'Dépots & Retraits',
      descriptionLarge: 'Dépots & Retraits',
      logo: '/images/services/eightStarz.png',
      bannerImage: '/images/services/eightStarz.png',
      idFindingMockup: '/images/screenshots/eightStarz-account-id-getting.webp',
      color: '#771512',
      isAvailable: true,
      onlyGa: true,
      isDarkBg: true,
      group: 'recharges'
    },
    {
      id: 'melbet',
      name: 'Melbet',
      bookmaker: 'Melbet',
      description: 'Dépots & Retraits',
      descriptionLarge: 'Dépots & Retraits',
      logo: '/images/services/melbetIcon.svg',
      bannerImage: '/images/services/melbetIcon.svg',
      idFindingMockup: '/images/screenshots/melbet-account-id-getting.png',
      color: '#272727',
      isAvailable: true,
      isDarkBg: true,
      group: 'recharges'
    },
    {
      id: 'usdt',
      name: 'USDT',
      description: 'Achat & Vente',
      descriptionLarge: 'Achat & Vente',
      logo: '/images/services/usdtIcon.svg',
      bannerImage: '/images/services/usdtIcon.svg',
      color: '#55AD94',
      isAvailable: true,
      isDarkBg: false,
      group: 'trade'
    }
  ],
  SERVICES_OPTIONS: {
    '1xbet': [
      {
        serviceId: '1xbet',
        id: 'fund',
        title: 'Dépôt 1xbet',
        description: 'Déposez rapidement sur votre compte 1xBet.',
        smallDescription: 'Lancez un dépot instantané'
      },
      {
        serviceId: '1xbet',
        id: 'withdraw',
        title: 'Retrait 1xbet',
        description: 'Retirez vos fonds 1xBet simplement.',
        smallDescription: 'Retirez vos gains'
      }
    ],

    '1win': [
      {
        serviceId: '1win',
        id: 'fund',
        title: 'Dépôt 1win',
        description: 'Déposez rapidement sur votre compte 1Win.',
        smallDescription: 'Lancez un dépot instantané'
      },
      {
        serviceId: '1win',
        id: 'withdraw',
        title: 'Retrait 1win',
        description: 'Retirez vos fonds 1Win simplement.',
        smallDescription: 'Retirez vos gains'
      }
    ],

    betwinner: [
      {
        serviceId: 'betwinner',
        id: 'fund',
        title: 'Dépôt betwinner',
        description: 'Déposez rapidement sur votre compte BetWinner.',
        smallDescription: 'Lancez un dépot instantané'
      },
      {
        serviceId: 'betwinner',
        id: 'withdraw',
        title: 'Retrait betwinner',
        description: 'Retirez vos fonds BetWinner simplement.',
        smallDescription: 'Retirez vos gains'
      }
    ],

    melbet: [
      {
        serviceId: 'melbet',
        id: 'fund',
        title: 'Dépôt melbet',
        description: 'Déposez rapidement sur votre compte MelBet.',
        smallDescription: 'Lancez un dépot instantané'
      },
      {
        serviceId: 'melbet',
        id: 'withdraw',
        title: 'Retrait melbet',
        description: 'Retirez vos fonds MelBet simplement.',
        smallDescription: 'Retirez vos gains'
      }
    ],

    eightStarz: [
      {
        serviceId: 'eightStarz',
        id: 'fund',
        title: 'Dépôt 888Starz',
        description: 'Déposez rapidement sur votre compte 8Starz.',
        smallDescription: 'Lancez un dépot instantané'
      },
      {
        serviceId: 'eightStarz',
        id: 'withdraw',
        title: 'Retrait 888Starz',
        description: 'Retirez vos fonds 8Starz simplement.',
        smallDescription: 'Retirez vos gains'
      }
    ],

    pm: [
      {
        serviceId: 'pm',
        id: 'buy',
        title: 'Achat PM',
        description: 'Achetez du Perfect Money rapidement.',
        smallDescription: 'Achat rapide'
      },
      {
        serviceId: 'pm',
        id: 'sell',
        title: 'Vente PM',
        description: 'Vendez votre Perfect Money facilement.',
        smallDescription: 'Vente rapide'
      }
    ],

    usdt: [
      {
        serviceId: 'usdt',
        id: 'buy',
        title: 'Achat USDT',
        description: 'Achetez du USDT rapidement.',
        smallDescription: 'Achat rapide'
      },
      {
        serviceId: 'usdt',
        id: 'sell',
        title: 'Vente USDT',
        description: 'Vendez votre USDT facilement.',
        smallDescription: 'Vente rapide'
      }
    ],

    wallet: [
      {
        serviceId: 'wallet',
        id: 'fund',
        title: 'Dépôt Wallet',
        description: 'Déposez rapidement sur votre portefeuille.',
        smallDescription: 'Dépôt rapide'
      },
      {
        serviceId: 'wallet',
        id: 'withdraw',
        title: 'Retrait Wallet',
        description: 'Retirez vos fonds simplement.',
        smallDescription: 'Retrait rapide'
      }
    ],

    giftCard: [
      {
        serviceId: 'giftCard',
        id: 'buy',
        title: 'Achat Gift Card',
        description: 'Achetez des Gift Cards rapidement.',
        smallDescription: 'Achat rapide'
      },
      {
        serviceId: 'giftCard',
        id: 'sell',
        title: 'Vente Gift Card',
        description: 'Vendez vos Gift Cards facilement.',
        smallDescription: 'Vente rapide'
      }
    ]
  }
};
